import type { ApiService, Logger } from "@packages/common";
import { type Dealer, type DealerApiResponseDTO, SellerShield } from "./dtos";

import { API, LOGGER } from "@packages/common";
import { Inject, Injectable } from "@webmotors/ioc";

import { CONFIG, type Config } from "@packages/config";
import { DEALER_SERVICE } from "./dealer.types";

@Injectable(DEALER_SERVICE)
export class DealerService {
  private readonly logger: Logger;

  constructor(
    @Inject(LOGGER) loggerFactory: Logger,
    @Inject(API) private readonly apiService: ApiService,
    @Inject(CONFIG) private readonly config: Config
  ) {
    this.logger = loggerFactory.create(DEALER_SERVICE);
  }

  async get(id: string | null): Promise<Dealer | null> {
    try {
      if (!id) {
        this.logger.info("[Get] No ID provided");
        return null;
      }

      const response = await this.apiService.get<unknown, DealerApiResponseDTO>(
        `/dealer/info/${id}`
      );

      const { shield = "" } = response;

      const dealerImageUrl = (() => {
        if (
          shield?.includes(SellerShield.P) ||
          shield?.includes(SellerShield.M) ||
          shield?.includes(SellerShield.G)
        ) {
          const path = `${this.config.sellerShieldImage}${id}`;
          return {
            id,
            name: shield,
            alt: "Banner dealer",
            bannerDesktop: `${path}/DESKTOP.jpg`,
            bannerMobile: `${path}/MOBILE.jpg`,
          };
        }
        return null;
      })();

      return dealerImageUrl || null;
    } catch (error) {
      this.logger.error("[Get] Error fetching dealer info: ", error);

      return null;
    }
  }
}
